import { useMutation } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IScanPackageForEvaluationData } from '../../../types';

/**
 * This is to track the scan package for creating evaluation mutation keys in
 * react query cache.
 */
const SCAN_PACKAGE_FOR_CREATING_EVALUATION_MUTATION_KEY =
  'scan-package-for-creating-evaluation-mutation-key';

interface IUseScanPackageForCreatingEvaluationParams {
  onSuccessCallback: (data: IScanPackageForEvaluationData) => void;
}

/**
 * React Query mutation function for scanning a package while creating an
 * evaluation i.e. the first step in creating an evaluation.
 */
export const useScanPackageForCreatingEvaluation = ({
  onSuccessCallback,
}: IUseScanPackageForCreatingEvaluationParams) => {
  const {
    data,
    error,
    isError,
    isPending,
    mutate: scanPackageForCreatingEvaluation,
    reset: resetScanPackageForCreatingEvaluation,
  } = useMutation({
    mutationKey: [SCAN_PACKAGE_FOR_CREATING_EVALUATION_MUTATION_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.scanPackageForCreatingEvaluation,
    onSuccess: onSuccessCallback,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetScanPackageForCreatingEvaluation,
    scanPackageForCreatingEvaluation,
  };
};
